import { components } from "react-select"
import styled from "styled-components"

export const StyledControl = styled<any>(components.Control)`
  && {
    border-color: var(--color-neutral-75);
    border-radius: 2px;
    border-width: 2px;
    padding: var(--size-0_5) var(--size-2);
    box-shadow: none;
    transition: border var(--duration-200);
    opacity: ${({ isDisabled }) => (isDisabled ? "0.5" : "1")};
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
    ${({ isDisabled }) => isDisabled && "pointer-events: auto;"}

    background-color: ${(props) =>
      props.selectProps.variant === "default"
        ? "transparent"
        : "var(--color-neutral-10)"};

    :hover {
      border-color: var(--color-neutral-75);
    }
    border-color: ${(props) => {
      if (props.selectProps.state === "error")
        return "var(--color-error) !important;"
      if (props.selectProps.state === "warning")
        return "var(--color-warning) !important;"
      if (props.isFocused) return "var(--color-primary-light) !important;"
    }};
    ${(props) => {
      if (props.selectProps.size === "small")
        return "min-height:  var(--size-8)"
      return "min-height:  var(--size-9)"
    }};
  }
`

export const StyledSingleValue = styled<any>(components.SingleValue)`
  && {
    color: var(--color-text-400);
    margin: 0;
    display: inline-flex;
  }
`

export const StyledPlaceholder = styled<any>(components.Placeholder)`
  && {
    color: var(--color-text-300);
    margin: 0;
  }
`

export const StyledMenuList = styled<any>(components.MenuList)`
  && {
    padding: 0;
  }
`

export const StyledMenu = styled<any>(components.Menu)`
  && {
    padding: var(--size-2) 0;
    box-shadow: var(--elevation-2);
    border: none;
    margin-top: var(--size-1_5);
    border-radius: var(--size-1);
  }
`

export const StyledOption = styled<any>(components.Option)`
  && {
    display: flex;
    justify-content: space-between;
    background-color: transparent;
    color: var(--color-text-300);
    padding: var(--size-1_5) var(--size-3);
    cursor: pointer;

    :not(:last-child) {
      margin-bottom: var(--size-1_5);
    }
    :hover,
    :focus {
      background-color: var(--color-neutral-10);
    }

    ${(props) =>
      props.isFocused && "background-color: var(--color-neutral-10);"}
  }
`
export const StyledOptionLabel = styled.div`
  display: flex;
  align-items: center;
  > *:not(:last-child) {
    margin-right: var(--size-2);
  }
`

export const StyledValueContainer = styled<any>(components.ValueContainer)`
  && {
    padding: 0;
    margin-right: var(--size-2);
  }
`

export const StyledInput = styled<any>(components.Input)`
  && {
    margin: 0;
    padding: 0;
  }
`

export const StyledDropdownIndicator = styled<any>(
  components.DropdownIndicator
)`
  && {
    margin: 0;
    padding: 0;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  }
`

export const StyledClearIndicator = styled<any>(components.ClearIndicator)`
  && {
    margin: 0 var(--size-1_5);
    padding: 0;
    color: var(--color-text-300) !important  ;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  }
`
